
// src/pages/HomePage.jsx
import React from 'react';
import Banner from '../components/home/Banner';
import LatestReleases from '../components/home/LatestReleases';
import SocialLinks from '../components/home/SocialLinks';
import AudioPlayer from '../components/library/AudioPlayer';


const HomePage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Banner />
      <div className="mt-12">
        <h2 className="text-3xl font-bold mb-6 text-gray-100">Latest Releases</h2>
        <LatestReleases />
      </div>
      <div className="mt-12">
        <h2 className="text-3xl font-bold mb-6 text-gray-100">Connect</h2>
        <SocialLinks />
      </div>
      <div className="fixed bottom-0 left-0 right-0 z-50">
        <AudioPlayer />
      </div>
    </div>
  );
};

export default HomePage;